enum StatusCode {
    NONE = 'NONE',
    PENDING = 'PENDING',
    COMPLETE = 'COMPLETE',
    ERROR = 'ERROR'
};

export default StatusCode;